import React from "react";
import { Spinner } from "components";
import { useIsProductLoading } from "stores/product";

export const InputTitle = ({
  title = null,
  isloading = false,
}: {
  title?: string | null;
  isloading?: boolean;
}) => {
  const isProductLoading = useIsProductLoading();

  if (!title) {
    return;
  }

  return (
    <div className="d-flex align-items-center mb-4">
      <h5 className="me-3 mb-0">{title}</h5>
      {isProductLoading && isloading && <Spinner size="xxs" />}
    </div>
  );
};
